import React from "react";

import { UserAuth } from "../../context/AuthContext";
import SearchBar from "../../components/MemberManagement/SearchBar/SearchBar";
import MembersTable from "../../components/MemberManagement/MembersTable/MembersTable";
import strings from "../../locales/ro.json"

import "./UserManagement.css";
import HeaderElement from "../../components/HeaderElement/HeaderElement";
import FloatingButton from "../../components/Buttons/FloatingButton/FloatingButton";
import { useNavigate } from "react-router-dom";
import LoadingCircle from "../../components/Global/LoadingCircle";
import requestHandler from "../../utils/requestHandler";


const UserManagement = () => {
  const { user } = UserAuth();

  const [users, setUsers] = React.useState([]);
  const [gotData,setGotData] = React.useState(false);
  const navigate = useNavigate()

  const backFunction = () => {
    navigate("/admin")
  }

  React.useEffect(() => {
    if (user.accessToken) {
      const userData = async () => {
        try {
          const myAuthToken =
          `Bearer ${user.accessToken}`;
          const result = await requestHandler("users","GET",myAuthToken);
          setUsers(result);
          setGotData(true);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
        //  finally {
        //   setLoading(false);
        // }
      };
      userData();
    }
  }, [user]);

  React.useEffect(() => {
    setFilteredUsers(users);
  }, [users]);

  const [filteredUsers, setFilteredUsers] = React.useState(users);

  const handleFilterChange = (event) => {
    // setFilter(event.target.value);
    setFilteredUsers((prevArr) => {
      let newArr = [];

      newArr = users.filter((element) => {
        let searchTerm = event.target.value.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return element["name"].toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(searchTerm);
      });
      return newArr;
    });
  };
  return (
    <div>
      <div className="userManagementContainer">
        <HeaderElement headerText={strings.usermanagement.title} />
        <SearchBar
          handleChange={handleFilterChange}
        />
        {users.length !== 0 && <MembersTable users={filteredUsers} />}
        {users.length === 0 && <LoadingCircle/>}
      </div>
    </div>
  );
};

export default UserManagement;
